<template>
    <div class="page">
        <Nav defaultPath="/aboutUs"></Nav>
        <Blurb class="needVisible"></Blurb>
        <Founder class="needVisible"> </Founder>
        <ContactUs></ContactUs>
        <div class="totop" @click.stop="toTop()" v-if="showGoTop">
            <img src="https://4d-ai.chat/img/totop.png">
        </div>
    </div>
</template>
<script>
import Nav from '@/components/Nav.vue';
import Blurb from '@/components/Blurb.vue';
import Founder from '@/components/Founder.vue';
import ContactUs from '@/components/ContactUs.vue';
export default {
    components: {
        Nav,
        Blurb,
        Founder,
        ContactUs
    },
    data() {
        return {
            showGoTop: false,
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll, true);
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                } else {
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        const boxes = document.querySelectorAll('.needVisible');
        boxes.forEach(box => {
            observer.observe(box);
        });
    },
    methods: {
        handleScroll() {
            let scrolltop = document.documentElement.scrollTop;
            if (scrolltop > window.innerHeight) {
                this.showGoTop = true
            } else {
                this.showGoTop = false
            }
        },
        toTop() {
            document.documentElement.scrollTop = 0;
        },
    }
}
</script>
<style scoped>
@media (max-width: 768px) {
    .page {
        padding: 0 !important;
    }

    .totop {
        width: 48px !important;
        bottom: 100px !important;
        height: 56px !important;
    }
}
</style>
<style scoped lang="less">
.page {
    box-sizing: border-box;
    padding: 64px 0 0;

    .needVisible {
        opacity: 0;
        transform: translateY(20px);
        transition: all 1s ease-out;
    }

    .visible {
        opacity: 1;
        transform: translateY(0);
    }

    .totop:hover {
        background: #2743af;
    }

    .totop {
        width: 48px;
        height: 56px;
        background-color: #243c8a;
        position: fixed;
        z-index: 20;
        right: 30px;
        bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        cursor: pointer;

        img {
            width: 45%;
        }
    }
}
</style>